<template>
  <div class="n_invoiceMachine">
    <div class="n_content">
      <div class="flex just_bettw n_margin">
        <p class="n_name">发票类型</p>
        <p class="n_text">增值税电子普通发票</p>
      </div>
      <div class="flex just_bettw n_margin">
        <p class="n_name">抬头类型</p>
        <van-radio-group v-model="from.member_type" direction="horizontal">
          <van-radio name="1" checked-color="#ee0a24">个人</van-radio>
          <van-radio name="2" checked-color="#ee0a24">企业</van-radio>
        </van-radio-group>
      </div>
      <div class="flex just_bettw n_margin">
        <p class="n_name">发票抬头</p>
        <input type="text" v-model="from.name" placeholder="填写需要开具发票的姓名" />
      </div>
      <div class="flex just_bettw n_margin" v-if="from.member_type == 2">
        <p class="n_name">税号</p>
        <input type="text" v-model="from.tax_code" placeholder="纳税人识别号" />
      </div>
      <div class="flex just_bettw">
        <p class="n_name">发票内容</p>
        <p class="n_text">{{ from.type == 1 ? '预付卡' : '明细开具'}}</p>
      </div>
    </div>
    <div class="n_btn" @click="applyInvoiceFg">提交申请</div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      radio: '1',
      from: {
        order_ids: '',
        type: '',
        invoice_type: '1',
        name: '',
        content_type: '',
        member_type: '1',
      },
    }
  },
  created() {
    this.from.order_ids = this.$route.query.order_ids
    this.from.type = this.$route.query.type
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    //申请开票
    async applyInvoiceFg() {
      if (this.from.tax_code != '' && this.from.member_type == 2) {
        if (
          !/^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(
            this.from.tax_code
          )
        ) {
          Toast('请输入正确的税号')
          return
        }
      }
      this.from.content_type = Number(this.from.type) + 1
      let res = await this.http('MemberInvoice.applyInvoice', { ...this.from })
      if (res.status == 200) {
        Toast('申请发票成功，请等待开具')
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000)
      } else {
        Toast(res.msg)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.n_invoiceMachine {
  padding: 20px;
  background: rgba(247, 248, 250, 1);
}
.n_content {
  padding: 28px 30px;
  background: #ffffff;
  border-radius: 20px;
}
.just_bettw {
  justify-content: space-between;
  align-items: center;
}
.n_name {
  font-size: 28px;
  color: #343434;
}
.n_text {
  font-size: 24px;
  color: #343434;
}
.just_bettw input {
  font-size: 24px;
  color: #a2a2a2;
}
.n_margin {
  margin-bottom: 52px;
}
.n_btn {
  width: 686px;
  height: 96px;
  line-height: 96px;
  margin: 68px auto;
  background: #ee0a24;
  border-radius: 48px;
  font-size: 32px;
  color: #ffffff;
  text-align: center;
}
</style>